(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-gallery-slider"] && !Shopify.designMode) return;
  try {
    class ProductGallery {
    constructor(element) {
      this.slider = element;
      this.track = element.querySelector('.gallery-track');
      
      if (!this.track) return;

      this.slides = Array.from(this.track.children);
      this.isInfinite = element.dataset.infinite === 'true';
      this.slideCount = this.isInfinite ? this.slides.length / 2 : this.slides.length;
      
      this.isDragging = false;
      this.startPos = 0;
      this.currentTranslate = 0;
      this.prevTranslate = 0;
      this.animationID = null;

      this.init();
    }

    init() {
      // Mouse events
      this.track.addEventListener('mousedown', this.dragStart.bind(this));
      this.track.addEventListener('mousemove', this.drag.bind(this));
      this.track.addEventListener('mouseup', this.dragEnd.bind(this));
      this.track.addEventListener('mouseleave', this.dragEnd.bind(this));
      
      // Touch events - NOT passive so we can preventDefault
      this.track.addEventListener('touchstart', this.dragStart.bind(this), { passive: false });
      this.track.addEventListener('touchmove', this.drag.bind(this), { passive: false });
      this.track.addEventListener('touchend', this.dragEnd.bind(this));
      
      // Keyboard events directly on the slider element
      this.slider.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          
          if (event.key === 'ArrowLeft') {
            this.navigate(1);
          } else {
            this.navigate(-1);
          }
        }
      });
      
      // Auto-focus on hover for keyboard navigation
      this.slider.addEventListener('mouseenter', () => {
        this.slider.focus({ preventScroll: true });
      });
      
      // Prevent context menu and image drag
      this.track.addEventListener('contextmenu', (e) => e.preventDefault());
      this.track.querySelectorAll('img').forEach(img => {
        img.addEventListener('dragstart', (e) => e.preventDefault());
      });

      // Handle infinite scroll reset
      if (this.isInfinite) {
        this.track.addEventListener('transitionend', () => {
          if (!this.isDragging) {
            this.checkInfiniteScroll();
          }
        });
      }
    }

    navigate(direction) {
      if (!this.slides[0]) return;
      
      const slideWidth = this.slides[0].offsetWidth + parseInt(getComputedStyle(this.track).gap || 0);
      const moveAmount = slideWidth * direction;
      
      this.currentTranslate += moveAmount;
      this.prevTranslate = this.currentTranslate;
      
      this.track.style.transition = 'transform 0.5s ease-out';
      this.setPosition();
      
      if (this.isInfinite) {
        setTimeout(() => this.checkInfiniteScroll(), 500);
      } else {
        const maxTranslate = 0;
        const minTranslate = -(this.track.scrollWidth - this.slider.offsetWidth);
        this.currentTranslate = Math.max(Math.min(this.currentTranslate, maxTranslate), minTranslate);
        this.prevTranslate = this.currentTranslate;
        this.setPosition();
      }
    }

    getPositionX(event) {
      return event.type.includes('mouse') ? event.pageX : event.touches[0].clientX;
    }

    dragStart(event) {
      this.isDragging = true;
      this.startPos = this.getPositionX(event);
      this.startPosY = this.getPositionY(event);
      this.animationID = requestAnimationFrame(this.animate.bind(this));
      this.track.classList.add('is-dragging');
      this.track.style.cursor = 'grabbing';
      this.hasDetectedDirection = false;
      
      // Immediately prevent default on touch to stop any scroll
      if (event.type === 'touchstart') {
        event.preventDefault();
      }
    }

    drag(event) {
      if (!this.isDragging) return;
      
      const currentPosition = this.getPositionX(event);
      const currentPositionY = this.getPositionY(event);
      const diff = currentPosition - this.startPos;
      const diffY = currentPositionY - this.startPosY;
      
      // Always prevent default on touchmove to stop page scrolling
      if (event.type === 'touchmove') {
        event.preventDefault();
        event.stopPropagation();
      }
      
      // Detect if swipe is more horizontal than vertical
      if (!this.hasDetectedDirection && (Math.abs(diff) > 5 || Math.abs(diffY) > 5)) {
        const isHorizontal = Math.abs(diff) > Math.abs(diffY);
        if (!isHorizontal && Math.abs(diffY) > 10) {
          // Vertical swipe detected - cancel drag and allow page scroll
          this.isDragging = false;
          this.track.classList.remove('is-dragging');
          this.track.style.cursor = 'grab';
          cancelAnimationFrame(this.animationID);
          return;
        }
        this.hasDetectedDirection = true;
      }
      
      // Apply momentum multiplier for faster mobile scrolling
      const momentum = event.type === 'touchmove' ? 2 : 1;
      this.currentTranslate = this.prevTranslate + (diff * momentum);
    }

    getPositionY(event) {
      return event.type.includes('mouse') ? event.pageY : event.touches[0].clientY;
    }

    dragEnd() {
      if (this.isDragging) {
        this.isDragging = false;
        cancelAnimationFrame(this.animationID);
        
        if (!this.isInfinite) {
          const maxTranslate = 0;
          const minTranslate = -(this.track.scrollWidth - this.slider.offsetWidth);
          this.currentTranslate = Math.max(Math.min(this.currentTranslate, maxTranslate), minTranslate);
        }
        
        this.prevTranslate = this.currentTranslate;
        this.track.classList.remove('is-dragging');
        this.track.style.cursor = 'grab';
        
        this.track.style.transition = 'transform 0.5s ease-out';
        this.setPosition();
      }
    }

    animate() {
      if (this.isDragging) {
        this.setPosition();
        requestAnimationFrame(this.animate.bind(this));
      }
    }

    setPosition() {
      this.track.style.transform = `translateX(${this.currentTranslate}px)`;
    }

    checkInfiniteScroll() {
      if (!this.isInfinite || this.slideCount === 0) return;

      const slideWidth = this.slides[0].offsetWidth + parseInt(getComputedStyle(this.track).gap || 0);
      const singleSetWidth = slideWidth * this.slideCount;
      
      if (this.currentTranslate < -singleSetWidth) {
        this.track.style.transition = 'none';
        this.currentTranslate = this.currentTranslate + singleSetWidth;
        this.prevTranslate = this.currentTranslate;
        this.setPosition();
        
        requestAnimationFrame(() => {
          this.track.style.transition = 'transform 0.5s ease-out';
        });
      }
      
      if (this.currentTranslate > 0) {
        this.track.style.transition = 'none';
        this.currentTranslate = this.currentTranslate - singleSetWidth;
        this.prevTranslate = this.currentTranslate;
        this.setPosition();
        
        requestAnimationFrame(() => {
          this.track.style.transition = 'transform 0.5s ease-out';
        });
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGalleries);
  } else {
    initGalleries();
  }

  function initGalleries() {
    document.querySelectorAll('[data-product-gallery]').forEach(gallery => {
      new ProductGallery(gallery);
    });
  }
  } catch(e) { console.error(e); }
})();

})();
